<script>
  const __ = wp.i18n.__;
  import { onMount } from 'svelte';
  import { createEventDispatcher } from 'svelte';
  import AutoComplete from 'simple-svelte-autocomplete';

  export let temp_center_list = [];
  export let center_list = [];
  export let center_list_for_search = [];
  const constant_center_list = [];
      
  export let title1 = '';
  export let title2 = '';
  let selectedCenter = {};

  export let filterAshrams = false;
  let filterTOK = false;

  let upperContainer;

  console.log('center_list', center_list);

  let selectedStateUts = 'allStatesUts';
  let is_tok_ashram = [];
  let viewFilter = false;
  let viewResetFilterTag = false;
  let active = 0;
  const aClass = "text-pm-white bg-pm-pink"
  const nAClass = "text-pm-black bg-snd-banana"
  let selectedCenterSearchFieldName = 'post_title';

  function removeBackToTopClass(event){
    let back_to_top = document.getElementById('child_center_back_to_top');
    back_to_top.style.display = 'block'

    let back_to_items_center = document.getElementById('all_center_container_for_scroll');
    
    if (document.body.scrollTop > window.innerHeight || document.documentElement.scrollTop > window.innerHeight) {
      back_to_top.style.display = "block";
    } else {
      back_to_top.style.display = "none";
    }
  }

  function backtofindcenter(){
    document.getElementById('all_center_list_container').scrollIntoView({
          behavior: 'smooth',
          block: 'center', 
          inline: 'nearest' 
        });
    let back_to_top = document.getElementById('child_center_back_to_top');
    back_to_top.style.display = 'none'

    let find_center_sticky_dropdown = document.getElementById('find_center_sticky_dropdown');
    //find_center_sticky_dropdown.style.display = 'none'
  }

  async function handleSelectChange(event) {
      //let back_to_top = document.getElementById('child_center_back_to_top');
      let find_center_sticky_dropdown = document.getElementById('find_center_sticky_dropdown');
  
      if(selectedStateUts != 'allStatesUts'){
        //back_to_top.style.display = 'block'
        find_center_sticky_dropdown.style.display = 'block'
        document.getElementById('child_center_'+selectedStateUts).scrollIntoView({
          behavior: 'smooth',
          block: 'center', 
          inline: 'nearest' 
        });
      }
    }

    function locationChangeForAllCenters() {
        if(selectedCenter.guid !== undefined){
          //console.log('locationChangeForAllCenters', selectedCenter.guid);
          window.open(selectedCenter.guid, "_blank");
        }
    }

    function handleFilterSelectChange(event) {
    console.log(selectedStateUts);
      if(selectedStateUts != 'allStatesUts'){
           document.getElementById('child_center_'+selectedStateUts).scrollIntoView({
              behavior: 'smooth',
              block: 'center', 
              inline: 'nearest' 
            });
        }
    }

    function applyFilterAshrams(event){
      viewResetFilterTag = true;
      if(active == 1){
        active = 0;
        resetAllCenterFilter();
      }else{
        active = 1;
        filterAshrams = true;
        center_list = temp_center_list;
        center_list.forEach((eachStateCenterList, main_key) => {

        let ashram_center = [];
        for ( var key in eachStateCenterList.child_centers) {
          
          if(eachStateCenterList.child_centers[key].is_ashram == "1"){
              ashram_center.push(eachStateCenterList.child_centers[key]);
              eachStateCenterList.child_centers[key].show=1;
            }else{
              eachStateCenterList.child_centers[key].show=0;
            }

        }

        if(ashram_center.length > 0){
          eachStateCenterList.show = 1;
        }else{
          eachStateCenterList.show = 0;
        }
        
        
        });
        center_list=center_list;
        console.log('constant_center_list', center_list);
      }
      
    }

    function resetAllFilter(event){
      active = 0;
      //viewResetFilterTag = false;
      selectedCenter = {};
      selectedStateUts = 'allStatesUts';
      if(viewFilter == false){
        viewResetFilterTag = false;
      }else if(viewFilter == true){
        viewResetFilterTag = true;
      }
      
      center_list = temp_center_list;
      center_list.forEach((eachStateCenterList, main_key) => {

      let ashram_center = [];
      for ( var key in eachStateCenterList.child_centers) {
        
        eachStateCenterList.child_centers[key].show=1;

      }
      eachStateCenterList.show = 1;
      
      });
    }

    function applyFilterTOK(event){
      viewResetFilterTag = true;
      if(active == 2){
        active = 0;
        resetAllCenterFilter();
      }else{
        active = 2;
        filterTOK = true;
        center_list = temp_center_list;
        center_list.forEach((eachStateCenterList, main_key) => {

        let tok_center = [];
        for ( var key in eachStateCenterList.child_centers) {
          
          if(eachStateCenterList.child_centers[key].is_tok == "1"){
              tok_center.push(eachStateCenterList.child_centers[key]);
              eachStateCenterList.child_centers[key].show=1;
            }else{
              eachStateCenterList.child_centers[key].show=0;
            }

        }

        if(tok_center.length > 0){
          eachStateCenterList.show = 1;
        }else{
          eachStateCenterList.show = 0;
        }
        
        
        });
        center_list=center_list;
        console.log('temp_center_list', temp_center_list);
      }
      
    }

    function resetAllCenterFilter(){
      center_list.forEach((eachStateCenterList, main_key) => {
        eachStateCenterList.show = 1;
        for ( var key in eachStateCenterList.child_centers) {
          eachStateCenterList.child_centers[key].show=1;
        }
      });
      center_list=center_list;
    }

    function onFilterClick () {
      viewFilter = !viewFilter;

      if(viewFilter == false){
        viewResetFilterTag = false;
      }else if(viewFilter == true){
        viewResetFilterTag = true;
      }
      
    }
    function getSearchedCenter(keyword){
      //console.log('keyword', keyword);
      //console.log('center_list_for_search', center_list_for_search);
      var tempArray = [];
      for ( var search_key in center_list_for_search) {
          //console.log(center_list_for_search[search_key]);
          if (center_list_for_search[search_key].post_title.includes(keyword) || center_list_for_search[search_key].post_title_en.toLowerCase().includes(keyword.toLowerCase())) {
            tempArray.push(center_list_for_search[search_key]);
          }
      }

      
      console.log('tempArray', tempArray, selectedCenterSearchFieldName);
      return tempArray;
    }

    onMount(() => {
      const el = document.querySelector('.center-search-dropdown');
      el.classList.remove("hide-arrow");


      });

    const removeHideArrowClass = async () => {
        const el = document.querySelector('.center-search-dropdown');
        el.classList.remove("hide-arrow");
    };

    let centerSearchlabelFieldNames = ['post_title', 'another_field_name'];
</script>
<div class="">
    <div class="container pt-[30px] md:pt-20 flex flex-col items-center">
      <div class="w-full" id="all_center_list_container">

        <div class="flex justify-between ">
          <div class="titles">
            <h1 class="text-pm-black">
                    {__(title2, "frontend")}
                 </h1>
          </div>
          <div class="font-bold grid grid-cols-2 gap-2" style="align-items: baseline;">
            <a on:click={(event) => resetAllFilter(event)} href="javascript:void(0);" class="text-pm-pink font-medium" type="reset">{viewResetFilterTag ? __("Clear Filter", "frontend") : ""}
            </a>
            <button on:click={onFilterClick} class="flex flex-row justify-center items-center gap-2 border border-pm-pink p-3 rounded-[10px]  text-pm-pink shadow-sm {viewFilter ? "bg-pm-pink border-pm-pink text-pm-white" : ""}">
              <span class="grid font-medium  course-card-filter-datalayer">
              {__("Filter", "frontend")}</span> 
              <i class="si-round si-tune font-bold text-xl"></i>
            </button>
          </div>
        </div>
        <div class="grid grid-cols-12">
            
            <div class="filter-holder col-span-12 {viewFilter ? "lg:flex" : "hidden" }">
              <div class="filter-container w-full relative z-[99] ">
    <form>
        <div class="grid grid-cols-2 md:grid-cols-4 my-5 gap-5 w-full" style="align-items: end;">
            <div class="w-full filters-holder">
                <label class="block tracking-wide text-pm-grey text-xs mb-1" for="language">
                    {__("States and Union Territories", "frontend")}
                </label>
                <div class="relative">
                  <select id="state-uts" name="state_uts" bind:value={selectedStateUts} on:change={handleFilterSelectChange} class="text-l block w-full h-[44px] bg-pm-white text-pm-grey border border-snd-lightgrey rounded-[10px] py-2 px-4 outline-0">
                        <option value="allStatesUts" class="text-l"> {__("Select", "frontend")}</option>
                        {#each center_list as center, i (center)}
                          <option value="{center.parent_state_id}" class="text-l">
                            {__(center.post_title, "frontend")}
                          </option>
                        {/each}
                      </select>
                <i class="select-down-arrow si-round si-expand-more text-3xl"></i>
              </div>
            </div>

            <div class="w-full filters-holder content-dropdown-holder">
                <label class="block tracking-wide text-pm-grey text-xs mb-1" for="language">
                    {__("Search City / Town / Village", "frontend")}
                </label>
                <div class="relative">
                  <AutoComplete
                      maxItemsToShowInList=15
                      bind:selectedItem="{selectedCenter}"
                      placeholder={__("Search", "frontend")}
                      orderableSelection=true
                      searchFunction="{getSearchedCenter}"
                      delay='200'
                      localFiltering={false}
                      labelFieldName=post_title
                      valueFieldName=guid
                      onChange={(ev) => locationChangeForAllCenters()}
                      className='w-full !min-w-full !h-[44px] center-search-dropdown '
                      dropdownClassName='text-left '
                      inputClassName="h-full !h-[44px] rounded-[10px] !border !border-solid !border-pm-grey bg-pm-white overflow-hidden"
                      on:click={removeHideArrowClass}
                      />
                </div>
            </div>

            <div class="w-full items-center gap-3">
                  <a  on:click={(event) => applyFilterAshrams(event)} class="w-full flex justify-center next-date-default_buttons py-3 text-l rounded-[30px] md:rounded-[50px] text-center shadow-course-btn {active ==1 ? aClass : nAClass}" href="javascript:void(0);">
                    {__("Ashram", "frontend")}
                  </a>
              </div>
              <div on:click={(event) => applyFilterTOK(event)} class="w-full items-center gap-3">
                  <a  class="w-full flex justify-center next-date-default_buttons py-3 px-6 text-l rounded-[30px] md:rounded-[50px] text-center shadow-course-btn {active ==2 ? aClass : nAClass}" href="javascript:void(0);">
                    {__("Temple of Knowledge", "frontend")}
                  </a>
              </div>
        </div>
    </form>
    
</div>
            </div>
         </div>
      </div>
  </div>
</div>

<div class="overflow-x-hidden" id="all_center_container_for_scroll" >
  <button on:click={() => backtofindcenter()} id="child_center_back_to_top" title="Go to find center" style="opacity: 1; z-index: 998; display: none;"><i class="si-solid si-chevron-up font-bold"></i></button>
  <div class="container pt-[10px] md:pt-5 flex flex-col items-center"> 
    <div class="w-full" >
      <div class="flex justify-between ">
        <div class="titles">
          <!--<h2 class="text-pm-black ">
            {__('States', "frontend")}
          </h2>-->
        </div>
      </div>
      <div class="column-stack" >
          {#each center_list as center, i (center)}
          {#if center.show == 1}
  <div class="column" id="child_center_{center.parent_state_id}">
    <a href="{center.guid}" target="_blank">
      <h5 class="column-header">
        {__(center.post_title, "frontend")}
      </h5>
    </a>
    {#if center.child_centers.length > 0}
        <ul class="column-list">
         {#each center.child_centers as child_center}
         {#if child_center.show == 1}
          <li class="flex">

                <a href="{child_center.guid}" class="text-left text-pm-pink font-semibold text-base" target="_blank">
                  {__(child_center.post_title, "frontend")}

                  {#if child_center.is_tok == "1" || child_center.is_ashram == "1"}
                    {#if child_center.is_tok == "1" && !(/Gnana Kshetra/i).test(child_center.post_title_en)}
                          {__('Temple of Knowledge', "frontend")}
                      {/if}

                      {#if child_center.is_ashram == "1" && !(/ashram/i).test(child_center.post_title_en)}
                        {__('Ashram', "frontend")}
                      {/if}
                  {/if}
                  
                </a>
          </li>
        {/if}
        {/each}
        </ul>
    {:else}
        <ul class="column-list"><li>{__("No Centers available", "frontend")}</li></ul>

    {/if}

  </div>
  {/if}
{/each}
      </div>
    </div>
  </div>
</div>

<style>
    input[type='date']::-webkit-inner-spin-button {
        display: none;
    }
    input:checked + div {  
        @apply bg-pm-yellow shadow-insett;  
    }  
    input:checked + div .tick {  
        display: flex;
    }
    .tooltip:hover .opacity-0 {
        opacity: 1;
    }
    .mapboxgl-ctrl-geocoder--input {
    height: 40px !important;
    padding: 6px 35px;
  }
  .filter-container select {
    border-color: #808080;
  }
  .filter-container select + .select-down-arrow{
    position: absolute;
    top: 50%;
    right: 10px;
    pointer-events: none;
    transform: translateY(-50%);
    color: #808080;
}

.column .column-list { 
  display:grid;  
  //display: flex;
      //flex-wrap: wrap;
      //flex-direction: row;
}
@media (max-width:767px) {
    .filters-holder {
        flex: 1 1 30%;
    }
} 

</style>